<div class="container-fluid" *ngIf="!loading">
  <form [formGroup]="userProfileForm">
    <mat-card class="system-config-card">
      <div class="row setting-row">
        <div class="col s8 m6">
          <h2 *ngIf="role != 'company'">{{role | titlecase}} Details</h2>
          <h2 *ngIf="role == 'company'">{{role | titlecase}} Details - {{company_name}} </h2>
        </div>
      </div>
      <div class="setting-section system-config">
        <div class="row details">
          <div class="col s12 m6 input-box">
            <mat-label>Name:</mat-label>
            <input type="text" matInput formControlName="name"
              [readonly]="!userProfileEditable && userProfileForm.get('name').disabled" placeholder="Enter name" />
          </div>
          <div class="col s12 m6 input-box" style="display: none;">
            <mat-label>Email:</mat-label>
            <input type="text" matInput formControlName="email" readonly placeholder="Enter email" />
          </div>
          <div class="col s12 m6 input-box" *ngIf="isAdmin">
            <mat-label>Company Name:</mat-label>
            <input type="text" matInput formControlName="company_name" placeholder="Enter company name" />
          </div>
          <div class="col s12 m6 input-box" *ngIf="isAdmin">
            <mat-label>Team Size:</mat-label>
            <mat-form-field appearance="outline" class="mat-form team-size-dropdown-width">
              <mat-select formControlName="team_size" placeholder="Select team size"
                [disabled]="!userProfileEditable && userProfileForm.get('team_size').disabled">
                <mat-option *ngFor="let option of teamSizeOptions" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col s12 m6 input-box" style="margin-bottom: 18px;">
            <mat-label>Role:</mat-label>
            <input type="text" matInput formControlName="role" readonly placeholder="Enter role" />
          </div>
        </div>
        <div class="row" *ngIf="userProfileEditable">
          <div class="col s12" style="text-align: right;">
            <button mat-raised-button color="primary" (click)="saveUserProfile()"
              [disabled]="userProfileForm.invalid">Save</button>
          </div>
        </div>
      </div>
    </mat-card>
  </form>

  <!-- Email & Phone Verification Section -->
  <div class="row" *ngIf="isAdmin" style="display: flex; flex-wrap: wrap; margin: 0 -8px;">
    <!-- Email Verification Section -->
    <div class="col s12 m6" style="padding: 0 8px; margin-bottom: 16px;">
      <mat-card class="system-config-card" style="height: 100%; margin-bottom: 0;">
        <div class="row setting-row">
          <div class="col s12">
            <h2>Email Verification</h2>
          </div>
        </div>
        <div class="setting-section system-config">
          <div class="row details">
            <div class="col s12">
              <div *ngIf="!isEmailVerified()">
                <div style="background-color: #fff3e0; padding: 15px; border-radius: 8px; border-left: 4px solid #f57c00; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;">
                  <div style="display: flex; align-items: center; gap: 12px;">
                    <mat-icon style="color: #f57c00; font-size: 28px; width: 28px; height: 28px;">warning</mat-icon>
                    <div>
                      <strong style="color: #e65100; font-size: 15px;">Email Not Verified</strong>
                      <p style="margin: 4px 0 0 0; color: #666;">{{userProfileForm.get('email')?.value}}</p>
                    </div>
                  </div>
                  <button mat-raised-button color="primary" 
                    (click)="sendEmailVerification()" [disabled]="isSendingEmailVerification">
                    <mat-icon *ngIf="!isSendingEmailVerification" style="margin-right: 8px;">email</mat-icon>
                    <span *ngIf="!isSendingEmailVerification">Verify Email</span>
                    <span *ngIf="isSendingEmailVerification">Sending...</span>
                  </button>
                </div>
              </div>
              <div *ngIf="isEmailVerified()" style="background-color: #e8f5e9; padding: 15px; border-radius: 8px; border-left: 4px solid #4caf50;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <mat-icon style="color: #4caf50; font-size: 28px; width: 28px; height: 28px;">check_circle</mat-icon>
                  <div>
                    <strong style="color: #2e7d32; font-size: 15px;">Email Verified</strong>
                    <p style="margin: 4px 0 0 0; color: #1b5e20;">{{userProfileForm.get('email')?.value}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- Phone Number Verification Section -->
    <div class="col s12 m6" style="padding: 0 8px; margin-bottom: 16px;">
      <mat-card class="system-config-card" style="height: 100%; margin-bottom: 0;">
        <div class="row setting-row">
          <div class="col s12">
            <h2>Phone Number Verification</h2>
          </div>
        </div>
        <div class="setting-section system-config">
          <div class="row details">
            <div class="col s12">
              <div *ngIf="!isPhoneVerified()">
                <div style="background-color: #fff3e0; padding: 15px; border-radius: 8px; border-left: 4px solid #f57c00;">
                  <div style="display: flex; align-items: center; gap: 12px;">
                    <mat-icon style="color: #f57c00; font-size: 28px; width: 28px; height: 28px;">warning</mat-icon>
                    <div>
                      <strong style="color: #e65100; font-size: 15px;">Phone Number Not Verified</strong>
                      <p style="margin: 4px 0 0 0; color: #666;">Please verify your phone number.</p>
                    </div>
                  </div>
                </div>
                <button mat-raised-button color="primary" (click)="openPhoneVerificationModal()" style="margin-top: 12px;">
                  <mat-icon style="margin-right: 8px;">phone</mat-icon>
                  Verify Phone Number
                </button>
              </div>
              <div *ngIf="isPhoneVerified()" style="background-color: #e8f5e9; padding: 15px; border-radius: 8px; border-left: 4px solid #4caf50;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <mat-icon style="color: #4caf50; font-size: 28px; width: 28px; height: 28px;">check_circle</mat-icon>
                  <div>
                    <strong style="color: #2e7d32; font-size: 15px;">Phone Number Verified</strong>
                    <p style="margin: 4px 0 0 0; color: #1b5e20;">{{getVerifiedPhoneNumber()}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <form [formGroup]="billingAddressForm" *ngIf="isAdmin && isPhoneVerified()">
    <mat-card class="system-config-card billing-address-card">
      <div class="row setting-row">
        <div class="col s12">
          <h2>Billing Address</h2>
        </div>
      </div>
      <div class="setting-section system-config">
        <div class="billing-form-grid">
          <!-- Country Autocomplete -->
          <mat-form-field appearance="outline"
            [class.mat-form-field-invalid]="billingAddressForm.get('country')?.invalid && (billingAddressForm.get('country')?.touched || billingAddressForm.get('country')?.dirty)">
            <mat-label>Country</mat-label>
            <input type="text" matInput [formControl]="countryControl" [matAutocomplete]="autoCountry"
              placeholder="Search country" (blur)="onCountryInputBlur()" />
            <mat-autocomplete #autoCountry="matAutocomplete" (optionSelected)="onCountrySelected($event.option.value)">
              <mat-option *ngFor="let country of filteredCountries" [value]="country.name">
                {{ country.name }}
              </mat-option>
            </mat-autocomplete>
            <mat-error
              *ngIf="billingAddressForm.get('country')?.hasError('required') && (billingAddressForm.get('country')?.touched || billingAddressForm.get('country')?.dirty)">
              Country is required.
            </mat-error>
          </mat-form-field>

          <!-- State Autocomplete - Only show if states are available -->
          <mat-form-field appearance="outline" *ngIf="hasStates && states.length > 0"
            [class.mat-form-field-invalid]="billingAddressForm.get('state')?.invalid && (billingAddressForm.get('state')?.touched || billingAddressForm.get('state')?.dirty)">
            <mat-label>State</mat-label>
            <input type="text" matInput [formControl]="stateControl" [matAutocomplete]="autoState"
              placeholder="Search state"
              (blur)="billingAddressForm.get('state')?.markAsTouched()" />
            <mat-autocomplete #autoState="matAutocomplete" (optionSelected)="onStateSelected($event.option.value)">
              <mat-option *ngFor="let state of filteredStates" [value]="state.name">
                {{ state.name }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="billingAddressForm.get('state')?.hasError('required')">
              State is required for the selected country.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Address Line 1</mat-label>
            <input matInput formControlName="addressLine1" placeholder="Enter address line 1" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Address Line 2</mat-label>
            <input matInput formControlName="addressLine2" placeholder="Enter address line 2 (Optional)" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input matInput formControlName="city" placeholder="Enter city" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Zip Code</mat-label>
            <input matInput formControlName="zipCode" placeholder="Enter zip code" />
          </mat-form-field>
        </div>
        <div class="billing-btn-row">
          <button mat-raised-button color="primary" (click)="saveBillingAddress()"
            [disabled]="billingAddressForm.invalid">Save Billing Address</button>
        </div>
      </div>
    </mat-card>
  </form>

  <form [formGroup]="changePasswordForm">
    <mat-card class="system-config-card">
      <div class="row setting-row">
        <div class="col s8 m6">
          <h2>Change Password</h2>
        </div>
      </div>
      <div class="setting-section system-config changePassword">
        <div class="row" style="margin-bottom: 0px;">
          <div class="col s12 input-box">
            <mat-form-field class="input_fields" appearance="outline">
              <mat-label>Current Password</mat-label>
              <input [type]="hideCurrent ? 'password' : 'text'" matInput formControlName="currentPassword"
                placeholder="Enter current password" />
              <button mat-icon-button matSuffix class="passBtn" (click)="hideCurrent = !hideCurrent">
                <mat-icon [matTooltip]="hideCurrent ? 'Unlock' : 'Lock'">
                  <span class="material-symbols-outlined">
                    {{ hideCurrent ? "visibility_off" : "visibility" }}
                  </span>
                </mat-icon>
              </button>
              <mat-error
                *ngIf="changePasswordForm.get('currentPassword')?.hasError('required') && (changePasswordForm.get('currentPassword')?.dirty || changePasswordForm.get('currentPassword')?.touched)">
                Please enter current password </mat-error>
            </mat-form-field>
          </div>
          <div class="col s12 input-box">
            <mat-form-field class="input_fields" appearance="outline">
              <mat-label>New Password</mat-label>
              <input [type]="hideNew ? 'password' : 'text'" matInput formControlName="newPassword"
                placeholder="Enter new password" />
              <button mat-icon-button matSuffix class="passBtn" (click)="hideNew = !hideNew">
                <mat-icon [matTooltip]="hideNew ? 'Unlock' : 'Lock'">
                  <span class="material-symbols-outlined">
                    {{ hideNew ? "visibility_off" : "visibility" }}
                  </span>
                </mat-icon>
              </button>
              <mat-error
                *ngIf="changePasswordForm.get('newPassword')?.hasError('required') && (changePasswordForm.get('newPassword')?.dirty || changePasswordForm.get('newPassword')?.touched)">
                Please enter new password </mat-error>
              <mat-error *ngIf="changePasswordForm.get('newPassword')?.hasError('password')">{{
                changePasswordForm.get('newPassword')?.errors?.password }}</mat-error>
            </mat-form-field>
          </div>
          <div class="col s12 input-box" style="margin-bottom: 18px;">
            <mat-form-field class="input_fields" appearance="outline">
              <mat-label>Confirm New Password</mat-label>
              <input [type]="hideConfirm ? 'password' : 'text'" matInput formControlName="confirmPassword"
                placeholder="Confirm new password" />
              <button mat-icon-button matSuffix class="passBtn" (click)="hideConfirm = !hideConfirm">
                <mat-icon [matTooltip]="hideConfirm ? 'Unlock' : 'Lock'">
                  <span class="material-symbols-outlined">
                    {{ hideConfirm ? "visibility_off" : "visibility" }}
                  </span>
                </mat-icon>
              </button>
              <mat-error
                *ngIf="changePasswordForm.get('confirmPassword')?.hasError('required') && (changePasswordForm.get('confirmPassword')?.dirty || changePasswordForm.get('confirmPassword')?.touched)">
                Please enter confirm password </mat-error>
              <mat-error
                *ngIf="changePasswordForm.get('confirmPassword').value != changePasswordForm.get('newPassword').value  && (changePasswordForm.get('confirmPassword')?.dirty || changePasswordForm.get('confirmPassword')?.touched) && changePasswordForm.get('confirmPassword').value  != ''">
                Password does not match </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col s12 " style="text-align: right;">
            <button mat-raised-button class="save-btn"
              [disabled]="!changePasswordForm.valid || changePasswordForm.get('confirmPassword').value != changePasswordForm.get('newPassword').value"
              (click)="changePasswordAction()" style="width: auto;">
              Update Password
            </button>

          </div>
        </div>
      </div>
    </mat-card>
  </form>

  <form [formGroup]="userSettingForm">
    <mat-card class="system-config-card">
      <div class="row setting-row">
        <div class="col s8 m6">
          <h2>Own Profile Settings </h2>
        </div>
      </div>
      <div class="setting-section system-config">
        <div class="row details">
          <div class="col s12 m6 input-box" style="margin-bottom: 18px;">
            <div class="option ">
              <div class="row option-container">
                <div class="col s10 option-contain">
                  <h2 class="option-h2">Mute Notifications</h2>
                  <p class="option-p">Enable this to stop toast notifications for screenshots.</p>
                </div>
                <div class="col s2 toggle-contain">
                  <mat-slide-toggle color="primary" formControlName="disable_toast"
                    (change)="onDisableToast($event.checked)">
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </form>
</div>
<div class="box_section" *ngIf="loading">
  <div>
    <ngx-skeleton-loader style="margin: 20px 0px; width: 100%;" count="4"
      [theme]="{ 'border-radius': '2', height: '200px', width: '100%', padding: '16px 29px'}"></ngx-skeleton-loader>
  </div>
</div>